/* eslint-disable no-unused-vars */
// import unionBy from 'lodash/unionBy';

const initialState = {
  page_size: 10,
  page: 1,

  total_pages: null,
  results: [],
  total_records: 0,

  requestState: {
    isFetching: false,
    message: '',
    statusCode: null,
  },
};

const paginate = ({ types, setPaginationConfigType }) => {
  const [requestType, succcesType, errorType] = types;

  return (state = initialState, action) => {
    switch (action.type) {
      case setPaginationConfigType:
        return {
          ...state,
          page: action.page,
          page_size: action.page_size ? action.page_size : state.page_size,
        };

      case requestType:
        return {
          ...state,
          requestState: {
            isFetching: true,
            message: '',
            statusCode: null,
          },
        };

      case succcesType:
        return {
          ...state,

          page: action.response.data.page,
          total_pages: action.response.data.total_pages,
          results: action.response.data.results,
          total_records: action.response.data.count,

          requestState: {
            isFetching: false,
            message: '',
            statusCode: action.response.status,
          },
        };

      case errorType:
        return {
          ...state,

          requestState: {
            isFetching: false,
            message: action.response.data.message,
            statusCode: action.response.status,
          },
        };

      default:
        return state;
    }
  };

  // const updatePagination = (state = initialState, actions) => {
  //   switch (actions.type) {
  //     case requestType:
  //       return { ...state, isFetching: true };

  //     case succcesType:
  //       return {
  //         ...state,
  //         ids: actions.response.data.results,
  //         total_pages: actions.response.data.total_pages,
  //         requestState: {
  //           ...state.requestState,
  //           isFetching: false,
  //           message: '',
  //           statusCode: actions.response.status,
  //         },
  //       };

  //     case errorType:
  //       return {
  //         ...state,
  //         isFetching: false,
  //         message: actions.response.data.message,
  //         statusCode: actions.response.status,
  //       };

  //     default:
  //       return (state);
  //   }
  // };


  // return (state = { list: [], count: 0, isFetching: false }, actions) => {
  //   const key = mapActionToKey(actions);
  //   switch (actions.type) {
  //     case requestType:
  //       return {
  //         ...state,
  //         isFetching: true,
  //       };
  //     case succcesType:
  //       return {
  //         ...state,
  //         isFetching: false,
  //         count: actions.response.data.count,
  //         list: unionBy(state.list, actions.response.data.results, 'id'),
  //         [key]: updatePagination(state[key], actions),
  //       };
  //     case errorType:
  //       return ({
  //         ...state,
  //         requestState: {
  //           isFeching: false,
  //           message: actions.response.data.message,
  //           statusCode: actions.response.status,
  //         },
  //       });
  //     default:
  //       return (state);
  //   }
  // };
};

export default paginate;
